import { Upload, Sparkles, FileCheck2, Send, ScanLine } from "lucide-react";

const STEPS = [
  { n: 1, icon: <Upload className="w-5 h-5" />, title: "Dépôt sécurisé", desc: "Déposez bail, état des lieux, avis de FPS ou mise en demeure en 30 secondes.", time: "30 secondes" },
  { n: 2, icon: <Sparkles className="w-5 h-5" />, title: "Extraction & Chronologie en 47s", desc: "L'IA ordonne chronologiquement les faits, isole les montants contestés et structure le dossier.", time: "< 47 secondes" },
  { n: 3, icon: <FileCheck2 className="w-5 h-5" />, title: "Contrôle de complétude officiel", desc: "Vérification automatique des pièces manquantes et pointage des textes Légifrance.", time: "Automatique" },
  { n: 4, icon: <Send className="w-5 h-5" />, title: "Résolution & Action", desc: "Téléchargez le Pack Résolution amiable (8,99 €) ou transmettez le dossier pré-instruit à votre gestionnaire pro.", time: "1 clic" },
];

export function CommentCaMarche() {
  return (
    <section className="py-14" data-testid="comment-ca-marche">
      <div className="mb-8">
        <div className="j-label mb-2 flex items-center gap-2"><ScanLine className="w-3 h-3" /> Comment ça marche</div>
        <h2 className="j-h2 font-heading">Le parcours SaaS de bout en bout.</h2>
        <p className="text-sm mt-2 max-w-2xl text-slate-600">Un flux simple, mesuré et neutre. Aucune consultation juridique personnalisée.</p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 relative">
        {STEPS.map((s) => (
          <div key={s.n} className="j-card relative" data-testid={`step-${s.n}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-full flex items-center justify-center font-heading font-black flex-shrink-0 bg-[#10B981] text-white">{s.n}</div>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-[#10B981]/10 text-[#10B981]">{s.icon}</div>
            </div>
            <h3 className="font-heading font-black text-lg text-[#1E293B]">{s.title}</h3>
            <p className="text-sm mt-2 leading-relaxed text-slate-600">{s.desc}</p>
            <div className="mt-3 inline-flex items-center gap-1 text-[0.7rem] font-bold uppercase tracking-widest text-[#10B981]">⏱ {s.time}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
